import { Loader } from '@afterpaytouch/core'
import React, { FunctionComponent, useEffect } from 'react'
import {
  selectPurchaseMethod,
  setCheckoutStatus,
  setPaymentOptionsError,
  setSelectedPaymentType,
  useAppDispatch,
  useAppRouter,
  useAppropriatePaymentMethod,
  usePBIRejected,
} from '../../state'
import { PaymentType } from '@afterpay/types'
import { Route } from '../../config/router'
import { CheckoutStatus, TerminalErrorCode } from '../../model'
import { ErrorCode } from '@afterpaytouch/portal-api'
import { useTranslation } from 'next-i18next'

export const BankingServiceUnavailable: FunctionComponent = () => {
  const { t } = useTranslation()
  const hasPBIRejected = usePBIRejected()
  const dispatch = useAppDispatch()
  const paymentMethod = useAppropriatePaymentMethod()
  const { push } = useAppRouter()

  const handleDecline = (): void => {
    dispatch(
      setPaymentOptionsError({
        error: TerminalErrorCode.ErrorPCL,
        errorCode: ErrorCode.Error,
      })
    )
    if (!hasPBIRejected) {
      dispatch(setSelectedPaymentType(PaymentType.PBI))
      if (paymentMethod !== null) {
        dispatch(selectPurchaseMethod(paymentMethod))
      } else {
        dispatch(setCheckoutStatus(CheckoutStatus.LackOfEligiblePaymentMethod))
        push(Route.ADD_PAYMENT_METHOD)
        return
      }
      push(Route.SUMMARY)
    } else {
      push(Route.TERMINAL_ERROR)
    }
  }

  useEffect(() => {
    handleDecline()
  }, [])

  return (
    <>
      <Loader text={t('common:page:processing')} />
    </>
  )
}
